import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { ServiceHelper } from '../config';
import { GenericResponseModel } from '../models';
import { AppConfig } from '../config';
import { delay, map, tap } from 'rxjs/operators';

@Injectable()
export class BidIncrementService {
    readonly baseEndpoint: string = '/bid-increments/';

    constructor(public http: HttpClient, public serviceHelper: ServiceHelper, private appConfig: AppConfig) {
        var me = this;
    }

    knownValidBidAmounts: number[] = [];

    IsKnownValid(amount: number): boolean {
        return (this.knownValidBidAmounts.indexOf(amount) >= 0)
    }

    AdjustToIncrement(amount: number): Observable<any> {
        if (this.knownValidBidAmounts.indexOf(amount) >= 0) {
            // console.log('Known amount', amount)
            return of(<AdjustToIncrementModel>{ DecimalValue: amount })
        } else {
            // console.log('Unknown amount', amount)
        }

        var headers = this.serviceHelper.GetHeaders();

        return this.http.get<AdjustToIncrementModel>(this.appConfig.getConfig('apiUrl') + this.baseEndpoint + "adjust-to-increment/" + amount, { withCredentials: true, headers: headers })
            .pipe(
                tap(data => this.knownValidBidAmounts.push(data.DecimalValue)),
                map(data => data),
            );
    }
}
class AdjustToIncrementModel {
    DecimalValue?: number;
}